import * as React from 'react';
import { createSelectable, TSelectableItemProps } from '../../../../components/drag-select';
import { toLocalDateString, toSlashedShortDate } from '../../../../utils/date-utils';
import { TruckWithNotifications } from '../../../../transportation/models/communications/truck-delivery-schedule';
import { ShipmentStatusMetadata } from '../../../../transportation/models/enums/shipment-status';

// #region Component Props

interface IProps extends TSelectableItemProps {
    truck: TruckWithNotifications;
}

// #endregion

const TruckCommunicationsRow = (props: IProps) => {

    const { selectableRef, 
        isSelected, 
        isSelecting  
    } = props;

    let actualClass = 'order-selectable';
    actualClass += (props.truck.isChecked) ? ' highlight' : '';
    actualClass += (isSelecting) ? ' dragging' : '';
    actualClass += (isSelected) ? ' selected-already' : '';

    return <tr 
            ref={ selectableRef }
            className={`truck-row ${ actualClass }`}>
            <td>{ props.truck.id }</td>
            <td>
                <span className={ "text-uppercase shipment-status-color " + ShipmentStatusMetadata[props.truck.status].class }>
                    { ShipmentStatusMetadata[props.truck.status].display }
                </span>
            </td>
            <td>{props.truck.name}</td>
            <td>{props.truck.driverName}</td>
            <td>{props.truck.cutoffDate ? toSlashedShortDate(props.truck.cutoffDate) : ''}</td>
            <td>{props.truck.psSent ? `${toLocalDateString(props.truck.psSent, props.truck.timeZoneId)}` : ''}</td>
            <td>{props.truck.pdSent ? `${toLocalDateString(props.truck.pdSent, props.truck.timeZoneId)}` : ''}</td>
            <td>{props.truck.fdSent ? `${toLocalDateString(props.truck.fdSent, props.truck.timeZoneId)}` : ''}</td>


        </tr>;
};

export default createSelectable(TruckCommunicationsRow);
